import { LayoutComponent } from "@jelly/lesson";

import synthesis_1 from "./synthesis/synthesis-1";
import synthesis_2 from "./synthesis/synthesis-2";
import synthesis_3 from "./synthesis/synthesis-3";
import synthesis_4 from "./synthesis/synthesis-4";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 15],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>room impulse response synthesis and auralization</b>",
                  formatter: "html",
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    textTransform: "uppercase",
                    fontSize: "14px",
                    fontWeight: 800,
                    letterSpacing: "3.5px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "carouselPaginated",
              options: {
                components: [synthesis_1, synthesis_2, synthesis_3, synthesis_4],
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
